import { isRunning } from '@/components/assistant-ui/message-part-utils';

import type { AssistantState } from '@assistant-ui/react';

// `AuiIf` conditions. No component imports, so the polarity — the part the
// compiler can't check — stays cheap to unit-test.
export function messageIsCopied(s: AssistantState) {
  return s.message.isCopied;
}

export function messageIsNotCopied(s: AssistantState) {
  return !s.message.isCopied;
}

export function partIsStreaming(s: AssistantState) {
  return isRunning(s.part);
}
